<template>
  <div>
    <b-row class="justify-content-center">
      <b-col cols="12" sm="6">
        <label>Code de Validation :</label>
        <ValidationProvider
          ref="vee-verificationCode"
          v-slot="{ errors, classes }"
          :name="'verificationCode'"
          rules="required"
          mode="passive"
        >
          <b-input
            autofocus
            :value="object.verificationCode"
            @input="$emit('updateObject', 'verificationCode', $event)"
          />
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
        <b-row class="my-2">
          <b-col cols="auto" class="pr-0">
            <font-awesome-icon icon="info-circle" />
          </b-col>
          <!-- ???: FIXME: .. -->
          <b-col class="pl-2"> Lorem ipsum dolor sit amet, consectetur adipiscing elit </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    object: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>
